import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { Map, ArrowRight } from 'lucide-react';
const sitemapSections = [{
  title: 'Main Pages',
  links: [{
    name: 'Home',
    url: '#'
  }, {
    name: 'About Us',
    url: '#about'
  }, {
    name: 'Contact',
    url: '#contact'
  }]
}, {
  title: 'Destinations',
  links: [{
    name: 'Nepal',
    url: '#destination-nepal'
  }, {
    name: 'Tibet',
    url: '#'
  }, {
    name: 'Bhutan',
    url: '#'
  }]
}, {
  title: 'Activities & Experiences',
  links: [{
    name: 'All Activities',
    url: '#activities'
  }, {
    name: 'Spiritual Journeys',
    url: '#spiritual-journeys'
  }, {
    name: 'Trekking & Hiking',
    url: '#'
  }, {
    name: 'Cultural Tours',
    url: '#'
  }, {
    name: 'Adventure Sports',
    url: '#'
  }, {
    name: 'Wildlife Safari',
    url: '#'
  }]
}, {
  title: 'Popular Treks',
  links: [{
    name: 'Everest Base Camp Trek',
    url: 'https://project-everest-base-camp-trek-detail-page-148.magicpatterns.app/'
  }, {
    name: 'Annapurna Circuit',
    url: '#'
  }, {
    name: 'Langtang Valley Trek',
    url: '#'
  }, {
    name: 'Manaslu Circuit',
    url: '#'
  }]
}, {
  title: 'Resources & Guides',
  links: [{
    name: 'Everest Trek Guide',
    url: '#everest-trek-guide'
  }, {
    name: 'Blog',
    url: '#'
  }, {
    name: 'Essential Gear for Everest',
    url: '#blog-everest-gear'
  }, {
    name: 'Travel Tips',
    url: '#'
  }]
}, {
  title: 'Legal & Policies',
  links: [{
    name: 'Privacy Policy',
    url: '#privacy-policy'
  }, {
    name: 'Terms of Use',
    url: '#terms-of-use'
  }, {
    name: 'Cancellation Policy',
    url: '#'
  }, {
    name: 'Travel Insurance',
    url: '#'
  }]
}];
export function SitemapPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-2103">
      <Navbar data-id="element-2104" />

      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-gray-900 to-gray-800 py-20 mt-16" data-id="element-2105">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-2106">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex justify-center mb-6" data-id="element-2107">
            <div className="w-16 h-16 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center" data-id="element-2108">
              <Map className="text-white" size={32} data-id="element-2109" />
            </div>
          </motion.div>
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-2110">
            Sitemap
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="text-gray-300 text-lg" data-id="element-2111">
            Navigate through all pages and resources on our website
          </motion.p>
        </div>
      </div>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-2112">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-2113">
          {sitemapSections.map((section, sectionIndex) => <motion.div key={sectionIndex} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: sectionIndex * 0.1
        }} className="bg-white border border-gray-200 rounded-2xl p-6 hover:shadow-lg transition-shadow" data-id="element-2114">
              <h2 className="text-xl font-bold text-gray-900 mb-4 pb-3 border-b border-gray-200" data-id="element-2115">
                {section.title}
              </h2>
              <ul className="space-y-3" data-id="element-2116">
                {section.links.map((link, linkIndex) => <li key={linkIndex} data-id="element-2117">
                    <a href={link.url} target={link.url.startsWith('http') ? '_blank' : '_self'} rel={link.url.startsWith('http') ? 'noopener noreferrer' : undefined} className="group flex items-center justify-between text-gray-700 hover:text-[#0066FF] transition-colors" data-id="element-2118">
                      <span data-id="element-2119">{link.name}</span>
                      <ArrowRight size={16} className="text-gray-400 group-hover:text-[#0066FF] group-hover:translate-x-1 transition-all" data-id="element-2120" />
                    </a>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>

        {/* Additional Info */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="mt-16 bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-8 text-center border border-blue-100" data-id="element-2121">
          <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-2122">
            Can't Find What You're Looking For?
          </h3>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-2123">
            If you can't find the page you're looking for, please contact our
            team and we'll be happy to help you navigate to the right place.
          </p>
          <a href="#contact" className="inline-flex items-center gap-2 bg-[#0066FF] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#0052CC] transition-colors" data-id="element-2124">
            Contact Us <ArrowRight size={18} data-id="element-2125" />
          </a>
        </motion.div>
      </main>

      <Footer data-id="element-2126" />
    </div>;
}